import { useState } from "react";
import { Box, Tooltip } from "@mui/material";

const HHI_SCALE_MAX = 10000;

const LEVEL_COLOR = { Low: "#2E7D5B", Moderate: "#B45309", High: "#B23A3A", };

function levelColor(level) {
  return LEVEL_COLOR[level] || "#946E19";
}

function formatWholeNumber(value) {
  const num = typeof value === "number" ? value : parseFloat(value);
  return Number.isFinite(num) ? Math.round(num).toLocaleString("en-US") : "-";
}

function LesseeRevenueConcentrationPanel({ summary, items, onClick }) {
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  if (!summary) return null;

  const index = typeof summary?.concentration_index === "number" ? summary.concentration_index : parseFloat(summary?.concentration_index);
  const fillPct = Number.isFinite(index) ? Math.max(0, Math.min(100, (index / HHI_SCALE_MAX) * 100)) : 0;
  const level = summary?.concentration_level || "-";
  const barColor = levelColor(level);
  const largestSharePct = Array.isArray(items) && items.length > 0
    ? items.reduce((max, item) => {
        const pct = typeof item?.share_pct === "number" ? item.share_pct : parseFloat(item?.share_pct);
        return Number.isFinite(pct) && pct > max ? pct : max;
      }, 0)
    : null;

  const handleBarMouseMove = (event) => {
    setCursorPosition({ x: event.clientX, y: event.clientY });
  };

  const virtualAnchor = {
    getBoundingClientRect: () => ({ top: cursorPosition.y, left: cursorPosition.x, right: cursorPosition.x, bottom: cursorPosition.y, width: 0, height: 0, x: cursorPosition.x, y: cursorPosition.y, toJSON: () => {}, }),
  };

  return (
    <Box
      onClick={onClick}
      sx={{ display: "flex", alignItems: "center", gap: 4, py: 3, cursor: onClick ? "pointer" : "default" }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <Box sx={{ fontSize: 28, fontWeight: 700, color: "#1B2A4A", lineHeight: 1.1 }}>
          {formatWholeNumber(index)}
        </Box>
        <Box sx={{ fontSize: 13, fontWeight: 600, color: "#8E97A8", mt: 0.25 }}>
          {level} concentration
        </Box>
      </Box>
      <Box sx={{ flex: "1 1 auto" }}>
        <Tooltip
          title={largestSharePct != null ? `${largestSharePct.toFixed(2)}%` : `${fillPct.toFixed(1)}%`}
          arrow
          placement="top"
          slotProps={{ popper: { anchorEl: virtualAnchor } }}
        >
          <Box onMouseMove={handleBarMouseMove} sx={{ height: 8, borderRadius: "6px", backgroundColor: "#E2E5EC", overflow: "hidden", cursor: onClick ? "pointer" : "default" }} >
            <Box sx={{ height: "100%", width: `${fillPct}%`, backgroundColor: barColor, borderRadius: "6px" }} />
          </Box>
        </Tooltip>
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
          <Box sx={{ fontSize: 12, color: "#8E97A8" }}>Low</Box>
          <Box sx={{ fontSize: 12, color: "#8E97A8" }}>Moderate</Box>
          <Box sx={{ fontSize: 12, color: "#8E97A8" }}>High</Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LesseeRevenueConcentrationPanel;
